export interface ValidationResult {
  complete: boolean;
  missing: { field: string; message: string }[];
}

const REQUIRED_FIELDS = [
  { field: 'load_number',       message: 'Load number required for tracking.' },
  { field: 'pickup_date',       message: 'Pickup date required for scheduling.' },
  { field: 'pickup_city',       message: 'Pickup city required for routing.' },
  { field: 'delivery_date',     message: 'Delivery date required for commitment.' },
  { field: 'delivery_city',     message: 'Delivery city required for routing.' },
  { field: 'rate_total',        message: "No rate entered — can't invoice or calculate profit without this." },
  { field: 'customer_name',     message: 'Customer/broker name required for invoice.' },
  { field: 'loaded_miles',      message: "Miles missing — can't calculate RPM or driver pay." },
  { field: 'commodity',         message: 'Commodity required for invoice and BOL.' },
  { field: 'consignee_name',    message: 'Consignee name required for invoice.' },
  { field: 'consignee_address', message: 'Consignee address required for invoice and BOL.' },
  { field: 'weight_lbs',        message: 'Weight required for invoice and carrier liability.' },
];

export function validateLoad(load: Record<string, any>): ValidationResult {
  const missing = REQUIRED_FIELDS.filter(r => {
    const val = load[r.field];
    return !val || (typeof val === 'number' && val === 0) || (typeof val === 'string' && val.trim() === '');
  });
  return { complete: missing.length === 0, missing };
}
